// extracted by mini-css-extract-plugin
module.exports = {"RegisterCardHeader":"RegisterCardHeader_RegisterCardHeader__1Zb3g","RegisterCardHeader__exit":"RegisterCardHeader_RegisterCardHeader__exit__3shNP"};